import { render, staticRenderFns } from "./DeclutterReason.vue?vue&type=template&id=1ef4de65&"
import script from "./DeclutterReason.vue?vue&type=script&lang=js&"
export * from "./DeclutterReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports